'use strict';

angular.module('portal.login', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // portal routings
            // login page
            .state('portal.menus.login', {
                url: '/login?errorCode&surpressRedirect&statusId',
                templateUrl: paths.app + 'login/components/login/login.html',
                controller: 'Login',
                params: {
                    review: false,
                    messages: [],
                    keepMessages: false,
                    errorCode: null,
                    surpressRedirect: null,
                    statusId: null,
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
            .state('portal.menus.createaccount', {
                url: '/account/create?autofill',
                templateUrl: paths.app + 'login/components/create-account/create-account.html',
                controller: 'CreateAccount',
                params: {
                    messages: [],
                    autofill: "false",
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
            .state('portal.menus.forgotusername', {
                url: '/forgot/username',
                templateUrl: paths.app + 'login/components/forgot-username/forgot-username.html',
                controller: 'ForgotUsername',
                params: {
                    messages: []
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
            .state('portal.menus.forgotpassword', {
                url: '/forgot/password',
                templateUrl: paths.app + 'login/components/forgot-password/forgot-password.html',
                controller: 'ForgotPassword',
                params: {
                    messages: []
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
            .state('portal.menus.resetpassword', {
                url: '/reset/:token/:cameFromProfile',
                templateUrl: paths.app + 'login/components/reset-password/reset-password.html',
                controller: 'ResetPassword',
                params: {
                    messages: [],
                    token: null,
                    cameFromProfile: 'false',
                    keepMessages: false
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
    }])
;